import RichText from '@/app/components/RichText';

import Heading from '../Heading';
import P from '../P';
import Section from '../Section';
import getValues from '../utils/getValues';

const values = getValues();

const IpPatents = () => {
  return (
    <>
      <Heading tx="ip_patents_heading" />

      <Section title="ip_patents_ring_title">
        <ul>
          <RichText
            messageKey="ip_patents_ring_list_07_2025"
            tValues={values}
          />
        </ul>
      </Section>

      <Section title="ip_patents_app_title">
        <ul>
          <RichText messageKey="ip_patents_app_list_07_2025" tValues={values} />
        </ul>
      </Section>

      <Section title="copyright_registrations">
        <ul>
          <RichText
            messageKey="copyright_registrations_list"
            tValues={values}
          />
        </ul>
      </Section>

      <P tx="ip_registered_trademarks_intro" className="my-12" />

      <Section title="ip_registered_trademarks_title">
        <ul>
          <RichText
            messageKey="ip_registered_trademarks_list"
            tValues={values}
          />
        </ul>
      </Section>
    </>
  );
};

export default IpPatents;
